export async function Who5Update(
  who5Resp,
  metaFecha,
  who5Alegre,
  who5Tranquilo,
  who5Activo,
  who5Despejado,
  who5Interesan,
  tratamientoId,
  pacienteId,
  who5Id
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-who5-${metaFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-who5-${metaFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      who5Resp: who5Resp,
      metaFecha: metaFecha,
      who5Resp: who5Resp,
      metaFecha: metaFecha,
      who5Alegre: who5Alegre,
      who5Tranquilo: who5Tranquilo,
      who5Activo: who5Activo,
      who5Despejado: who5Despejado,
      who5Interesan: who5Interesan,
    },
  };

  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/who5/${who5Id}`,
      {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${ authToken }`,
          },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
